import React from "react";
import ReactDOM from "react-dom";
import IntlTelInput from 'react-intl-tel-input';
import 'react-intl-tel-input/dist/main.css';
export default class UpdateCVApplyForJobModal extends React.Component {

    state = {
        careerlevel: {
            name: '',
            fields: []
        },
        education: {
            name: '',
            fields: []
        },
        jobrole: {
            name: '',
            fields: []
        },
        languages: {
            name: '',
            fields: []
        },
        cities: window.CITIES_DATA,
        areas: [],
    }

    constructor(props) {
        super(props);
        let fields = {};
        if(typeof JOB_FIELDS !== 'undefined') {
            fields = window.JOB_FIELDS;
        }
        this.state = {
            cities: window.CITIES_DATA,
            areas: [],
            ...fields,
        };
            this.escFunction = this.escFunction.bind(this);
    }

    escFunction(event) {
        if (event.keyCode === 27) {
            this.onToggle();
        }
    }
    areas_cities(event){
        let _city_id = event.target.value;
        let _url = `${BASE.url}areas-by-city-id/${_city_id}`;
        fetch(_url)
        .then(res => res.json())
        .then(res => {
            if(res.status.status == 1)
            {
                this.setState({
                    areas: res.data,
                  });
            }
            else{
                this.setState({
                    areas: [{id: 0, name: " لاتوجد مناطق لهذة المدينة"}],
                  });
            }
        });
      }
    componentDidMount() {
        document.addEventListener("keydown", this.escFunction, false);
    }
    componentWillUnmount() {
        document.removeEventListener("keydown", this.escFunction, false);
    }

    onToggle = () => {
        let createChatModalElement = document.querySelector('#loginModal');
        ReactDOM.unmountComponentAtNode(createChatModalElement);
    }

    render() {
        const { careerlevel, education, jobrole, languages } = this.state;
        const cities = window.CITIES_DATA;
        const areas = this.state.areas;
        const baseurl= `${BASE.url}adverts/update-cv-apply-job`
        return (
            <div className='App'>
                <div className="content --wide-content">
                    <div id="infoModal" className="modal_v4">
                        <div className="modalBody">
                            <form method="post" action={baseurl}>
                                <h3 className="form-legend">بياناتك الشخصية</h3>
                                <label className="form-field">
                                    <b className="field-title">إسمك الرباعي</b>
                                    <input required type="text" name="sections[personal_details][0][display_name]" className="form-control" />
                                </label>
                                <label className="form-field">
                                    <b className="field-title">رقم هاتفك الجوال</b>
                                    <IntlTelInput
                                        required
                                        containerClassName="intl-tel-input"
                                        inputClassName="form-control"
                                        fieldName="login_number"
                                    />
                                </label>
                                <label className="form-field">
                                    <b className="field-title">{education.name}</b>
                                    <select required className="form-control" type="text" name="sections[personal_details][0][education_level_id]" className="form-control">
                                        {education.fields.map(item => <option key={item.value} value={item.value}>{item.label}</option>)}
                                    </select>
                                </label>
                                <label className="form-field">
                                    <b className="field-title">{jobrole.name}</b>
                                    <select required className="form-control" type="text" name="sections[personal_details][0][career_level_id]" className="form-control">
                                        {careerlevel.fields.map(item => <option key={item.value} value={item.value}>{item.label}</option>)}
                                    </select>
                                    <select required className="form-control" type="text" name="sections[personal_details][0][job_role]" className="form-control">
                                        {jobrole.fields.map(item => <option key={item.value} value={item.value}>{item.label}</option>)}
                                    </select>
                                </label>
                                <label className="form-field">
                                    <b className="field-title">المدينه - المنطقه</b>
                                    <select required type="text" name="sections[personal_details][0][city_id]" className="form-control" onChange={ev => this.areas_cities(ev)}>
                                        <option selected>المدينه</option>
                                        {cities.map(item => <option key={item.city_id} value={item.city_id}>{item.city_name}</option>)}
                                    </select>
                                    <select type="text" name="sections[personal_details][0][area_id]" className="form-control">
                                        <option selected>المنطقه</option>
                                        {areas.map(items => <option key={items.id} value={items.id}>{items.name}</option>)}
                                    </select>
                                </label>
                                <label className="form-field">
                                    <b className="field-title">الخدمة الوطنية</b>
                                    <select required type="text" name="sections[personal_details][0][military_service]" className="form-control">
                                        <option value="3">مؤدي الخدمة الوطنية</option>
                                        <option value="1">معفى من الخدمة الوطنية</option>
                                        <option value="2">مؤجل الخدمة</option>
                                    </select>
                                </label>
                                <label className="form-field">
                                    <b className="field-title">رخصة القيادة</b>
                                    <select required className="form-control" type="text" name="sections[personal_details][0][driving_license]" className="form-control">
                                        <option value="2">ليس لدي رخصة قيادة</option>
                                        <option value="1">رخصة قيادة خاصة</option>
                                    </select>
                                </label>
                                <h3 className="form-legend">آخر خبره عمل</h3>
                                <label className="form-field">
                                    <b className="field-title"> المسمى الوظيفى</b>
                                    <input required type="text" name="sections[work_experience][0][job_title]" className="form-control" />
                                </label>
                                <label className="form-field">
                                    <b className="field-title">أسم جهة العمل</b>
                                    <input required required type="text" name="sections[work_experience][0][company_name]" className="form-control" />
                                </label>
                                <label className="form-field">
                                    <b className="field-title">التاريخ من:</b>
                                    <input type="date" name="sections[work_experience][0][from_date]" className="form-control" />
                                </label>
                                <label className="form-field">
                                    <b className="field-title">التاريخ الى:</b>
                                    <input required type="date" name="sections[work_experience][0][to_date]" className="form-control" />
                                </label>
                                <h3 className="form-legend">آخر خبره عمل</h3>
                                <label className="form-field">
                                    <b className="field-title">عربي</b>
                                    <input type="checkbox" name="sections[languages][][language_id]" value={1} className="form-control" />
                                </label>
                                <label className="form-field">
                                    <b className="field-title">english</b>
                                    <input type="checkbox" name="sections[languages][][language_id]" value={2} className="form-control" />
                                </label>
                                <input type="hidden" name="job_id" value={this.props.advert_id} />
                                <div>بإضافة بياناتك الخاصه و سيرتك الذاتية انت توافق على مشاركتها مع الشركات من قبل موقع السوق.كوم</div>
                                <div className="modalFooter">
                                    <button className="btn primary-1-btn">قدم على الوظيفة</button>
                                    <a className="close" onClick={this.onToggle}>{modalV4.close}</a>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}